document.addEventListener('DOMContentLoaded', function () {
    for (let element of document.querySelectorAll('.js-sensorslider .js-heading')) {
        element.addEventListener('click', toggleSensorslider);
    }
    adjustSensorSliderHeight();

    window.addEventListener("resize", (e) => {
        adjustSensorSliderHeight();
    });
});

function toggleSensorslider(event) {
    let sensorSlider = event.target.closest('.js-sensorslider');
    let selected = event.target.closest('.js-sensor');

    for (let others of sensorSlider.querySelectorAll('.js-sensor')) {
        others.setAttribute('data-expanded', false);
    }

    selected.setAttribute('data-expanded', 'true');
}
function adjustSensorSliderHeight(){
    for (let slider of document.querySelectorAll('.js-sensorslider')) {

        let headingHeight = 0

        for (const heading  of slider.getElementsByClassName('js-heading')) {
            headingHeight += heading.scrollHeight;
        }

        let highestDescription = 0;
        for (const desc of slider.getElementsByClassName('css-js-description')) {
            if (desc.scrollHeight > highestDescription) {
               highestDescription = desc.scrollHeight;
            }
            desc.style.maxHeight = desc.scrollHeight + 'px';
        }
        const sliderHeight = headingHeight + highestDescription;
        slider.style.height = sliderHeight + 'px'
    }
}
